import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { MyApp } from './app.component'; 
import {BaselineLibModule, ConfigService, BaselineSharedModule} from 'baseline-lib'
import { APP_INITIALIZER } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { Global } from '../global/global';
import { DatePipe } from '@angular/common';
import { InAppBrowser } from '../../node_modules/@ionic-native/in-app-browser';
import { HomeModule } from './home/home.module';
import { CustomToast } from './shared/services/custom-toast';
import { HttpErrorInterceptor } from './error-interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http'; 
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './shared/shared.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    HomeModule,
    SharedModule,
    BrowserModule,
    BaselineLibModule,
    HttpClientModule,
    HttpModule,
    BaselineSharedModule,
    IonicModule.forRoot(MyApp),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    RouterModule.forRoot([  ]),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
      MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Global,
    DatePipe,
    InAppBrowser,
    CustomToast,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    { provide: APP_INITIALIZER, useFactory: (config: ConfigService) => () => config.load(environment.configFile), deps: [ConfigService], multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    }, 
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts